// src/pages/JourneyMap/phases/Step1Profile.jsx
// Passo 1 — PERFIL: Edy faz 3 perguntas sequenciais, salva no MongoDB
import React, { useState } from 'react';
import EdyAssistant from '../components/EdyAssistant';
import apiClient from '../../../lib/apiClient';

const QUESTIONS = [
  {
    key:         'empresa',
    edy_message: 'Olá! Eu sou o Eddy e vou te ajudar a turbinar suas vendas com IA! Pode me contar: qual é o nome do seu negócio?',
    label:       'Nome do seu negócio / empresa',
    placeholder: 'Ex: Pizzaria do João, Clínica Estética Maria...',
    mood:        'think',
  },
  {
    key:         'diferencial',
    edy_message: 'Show! Agora me diz: qual é o seu grande diferencial? O que te faz único no mercado?',
    label:       'Seu grande diferencial',
    placeholder: 'Ex: Entrega em 30 min, atendimento 24h, preço justo...',
    mood:        'think',
  },
  {
    key:         'dor_cliente',
    edy_message: 'Perfeito! Última pergunta: qual é a principal dor do seu cliente que você resolve?',
    label:       'Dor do cliente que você resolve',
    placeholder: 'Ex: Falta de tempo para cozinhar, custo alto com academia...',
    mood:        'think',
  },
];

export default function Step1Profile({ campaignId, onAdvance }) {
  const [qIdx, setQIdx]         = useState(0);
  const [answers, setAnswers]   = useState({ empresa: '', diferencial: '', dor_cliente: '' });
  const [value, setValue]       = useState('');
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [edyMood, setEdyMood]   = useState('think');

  const current = QUESTIONS[qIdx];

  const handleNext = async () => {
    if (value.trim().length < 3) {
      setError('Por favor, escreva pelo menos 3 caracteres.');
      return;
    }
    setError('');

    const updated = { ...answers, [current.key]: value.trim() };
    setAnswers(updated);

    if (qIdx < QUESTIONS.length - 1) {
      // Avança para próxima pergunta
      setValue('');
      setQIdx(qIdx + 1);
      return;
    }

    // Todas respondidas → persiste no MongoDB
    setSaving(true);
    setEdyMood('joinha');
    try {
      const r = await apiClient.request(`/mp/journey/${campaignId}/profile`, {
        method: 'PUT',
        body:   JSON.stringify(updated),
      });
      const d = await r.json();
      if (d.success) {
        onAdvance(d.campaign);
      } else {
        setError(d.message || 'Erro ao salvar perfil.');
        setEdyMood('think');
      }
    } catch {
      setError('Erro de conexão. Tente novamente.');
      setEdyMood('think');
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleNext(); }
  };

  const edyMsg = saving
    ? 'Salvando suas respostas no banco de dados...'
    : current.edy_message;

  return (
    <div className="jm-container">
      <EdyAssistant message={edyMsg} mood={edyMood} loading={saving} />

      <div className="jm-card">
        <div className="jm-question">
          <label>
            {current.label}
            <span> — pergunta {qIdx + 1} de {QUESTIONS.length}</span>
          </label>
          <input
            className="jm-input"
            type="text"
            placeholder={current.placeholder}
            value={value}
            onChange={e => { setValue(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
            autoFocus
            disabled={saving}
          />
          {error && <p style={{ color: 'var(--edy-red)', fontSize: '0.82rem', marginTop: 6 }}>{error}</p>}
        </div>

        {/* Progresso de perguntas */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
          {QUESTIONS.map((_, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                height: 3,
                borderRadius: 2,
                background: i <= qIdx ? 'var(--edy-violet)' : 'var(--edy-border)',
                transition: 'background .3s',
              }}
            />
          ))}
        </div>

        <button
          className="jm-btn-primary"
          onClick={handleNext}
          disabled={saving || value.trim().length < 3}
        >
          {saving
            ? 'Salvando...'
            : qIdx < QUESTIONS.length - 1
            ? 'Próxima pergunta →'
            : 'Concluir Perfil'}
        </button>
      </div>
    </div>
  );
}
